// @flow

import { observer } from "mobx-react";
import React from "react";

import "./VideoArrows.scss";

type Props = {
    show: boolean,
    isVideoPaused: boolean,
    canGoForward: boolean,
    canGoBackward: boolean,
    onForward: Function,
    onBackward: Function,
    progress: number,
};

@observer
export default class VideoArrows extends React.Component<Props> {
    render() {
        let classes = ["VideoArrows"];
        if (!this.props.show) {
            classes.push("VideoArrows--hide");
        }
        if (this.props.isVideoPaused) {
            classes.push("VideoArrows--pausedVideo");
        }

        let leftArrow = null;
        if (this.props.canGoBackward) {
            leftArrow = (
                <button
                    className="VideoArrows__left"
                    onClick={this.props.onBackward}
                >
                    <i className="fa fa-chevron-left" />
                </button>
            );
        }
        let rightArrow = null;
        if (this.props.canGoForward) {
            rightArrow = (
                <button
                    className="VideoArrows__right"
                    onClick={this.props.onForward}
                >
                    <i className="fa fa-chevron-right" />
                </button>
            );
        }

        return (
            <div className={classes.join(" ")}>
                {leftArrow}
                {rightArrow}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoArrows/VideoArrows.js